var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83065",
    "data-name": "Group 83065",
    transform: "translate(-541 -1943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23088",
    "data-name": "Path 23088",
    d: "M3903.756,0a19,19,0,1,1-19,19,19,19,0,0,1,19-19",
    transform: "translate(-3343.756 1943)",
    fill: "#cdcdcd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23089",
    "data-name": "Path 23089",
    d: "M4038.763,150.226l-3.6.014v11.741c1.153-.015,2.326.005,3.487,0,0-1.744,0-3.487.06-5.372,0-1.536.082-3.3,2.093-3.373,2.081-.079,2.116,1.791,2.119,3.354,0,1.726.053,4.422.025,5.391h3.607c.007-.232-.025-5-.025-5.391,0-.872.053-1.858.01-2.716a4.1,4.1,0,0,0-4.23-3.964,4.3,4.3,0,0,0-3.552,1.855c0-.5.009-1.06.009-1.539m-9.541,11.754h3.628c-.016-.874-.015-10.926-.015-11.74l-3.61,0Zm1.573-17.567a2.14,2.14,0,0,0-1.911,2.4,2.156,2.156,0,1,0,1.911-2.4",
    transform: "translate(-3477.866 1809.34)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social_linkedin.520f9e33df657eb5b01c872e8e4f9cd8.svg";
export { ForwardRef as ReactComponent };